type LogEntry = { status: string; dateModified: boolean }

// Returns true for events that are hidden under "Showing Alert only" and counted
// in "N Successful Events Hidden": plain completions and No Testing (NPT) when
// not date-modified. Mirrors legacy behaviour where a task log without dateModified
// is treated as a non-alert regardless of whether it was NPT or a normal complete.
export const isNonAlertEvent = (log: LogEntry): boolean =>
  (log.status === 'complete' || log.status === 'npt') && !log.dateModified

export const partitionTaskHistoryLogs = <T extends { log: LogEntry }>(
  entries: T[],
  showAlertsOnly: boolean,
): { visible: T[]; hiddenSuccessfulCount: number } => {
  const hiddenSuccessfulCount = entries.filter((entry) => isNonAlertEvent(entry.log)).length
  const visible = showAlertsOnly ? entries.filter((entry) => !isNonAlertEvent(entry.log)) : entries
  return { visible, hiddenSuccessfulCount }
}
